import type { LogoProps } from '../types';
import { Svg } from '../ThirdPartyLogo.styles';

const viewBox = {
  both: '0 0 137 49',
  vertical: '36 0 65 49',
  horizontal: '0 8.7 137 33',
  none: '36 8.7 65 33',
};

const AlamoLogo = ({ withPadding = 'both', ...props }: LogoProps) => (
  <Svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox[withPadding]}
    role="img"
    aria-hidden="true"
  >
    <title>Alamo</title>
    <path
      fill="#295eac"
      d="M96.44 40.95c2.3 0 4.17-2.02 4.17-4.52V13.27c0-2.5-1.87-4.52-4.17-4.53H40.19c-2.3 0-4.17 2.03-4.17 4.53v23.15c0 2.5 1.87 4.53 4.17 4.53h56.25Z"
    />
    <path
      fill="#fff100"
      d="M36.93 35.91V13.78c0-2.39 1.6-4.07 3.86-4.07h55.06c2.25 0 3.84 1.69 3.84 4.07v22.14c0 2.38-1.59 4.06-3.85 4.06H40.78c-2.25 0-3.85-1.68-3.85-4.07Zm61.83-.48h.02V14.26c0-2.27-1.33-3.63-3.53-3.63H41.4c-2.2 0-3.53 1.35-3.53 3.63v21.17c0 2.28 1.33 3.64 3.53 3.64h53.83c2.21 0 3.53-1.36 3.53-3.64ZM69.9 24.33v4.93l.03 1.78h-2.75c-.15-.43-.2-.56-.25-1.08a4.86 4.86 0 0 1-3.5 1.32c-1.58 0-3.2-.77-3.2-2.65 0-1.78 1.3-2.69 3.05-2.9l2.6-.33c.44-.06.97-.2.97-.72 0-1.01-1.22-1.06-1.93-1.06-1.37 0-1.5.85-1.58 1.38h-2.77c.31-2.78 2.54-3.17 4.69-3.17 1.47 0 4.08.16 4.64 2.5Zm-5.63 5.24c1.22 0 2.46-.69 2.46-1.8v-1.16c-.27.19-.73.34-1.87.5-1.02.15-1.87.37-1.87 1.36 0 .84.75 1.1 1.28 1.1Zm20.93-4.63v6.1h-2.71v-5.21c.07-1.08-.34-1.52-1.37-1.54-1.35-.04-1.6.53-1.6 1.61v5.14h-3.07v-5.15c0-.78-.03-1.58-1.28-1.6-1.28-.03-1.68.53-1.68 1.52v5.23h-2.95v-8.78h2.83v1.33h.04l.15-.3c.26-.55.55-1.15 2.08-1.15 1.5 0 2.17.48 2.87 1.46l.02-.03a3.26 3.26 0 0 1 2.74-1.43c2.01 0 3.93.8 3.93 2.8Zm-25.53-6.18v12.28h-2.85V18.76h2.85Zm-8.18 9.74H45.2l-1.06 2.54h-3.25l5.57-12.4h4.03l5.85 12.4h-3.7l-1.15-2.53v-.01Zm-3.2-7.2.01-.02h-.01v.01Zm0 0-1.99 4.84h4.11l-2.12-4.85Zm37.32 5.2c0-3.3 2.56-4.8 5.26-4.8 2.71 0 5.26 1.51 5.26 4.79 0 3.29-2.56 4.79-5.26 4.79-2.7 0-5.26-1.5-5.26-4.78Zm2.84-.01c0 1.17.38 2.77 2.42 2.77s2.42-1.6 2.42-2.77c0-1.16-.38-2.77-2.42-2.77s-2.42 1.61-2.42 2.77Zm8.72-5.14c0 .81-.56 1.28-1.18 1.28-.63 0-1.2-.47-1.2-1.28s.57-1.29 1.2-1.29 1.19.48 1.19 1.29h-.01ZM96 20.36c-.47 0-.85.4-.85.98 0 .6.38 1 .85 1 .46 0 .84-.4.84-.99s-.38-.99-.84-.99Zm.55 1.68h-.33l-.29-.58h-.13v.58h-.27v-1.39H96c.33 0 .53.1.53.42 0 .26-.14.35-.3.36l.32.6v.01ZM96 20.89h-.2v.33h.24c.12 0 .2-.02.2-.18 0-.14-.14-.15-.24-.15Z"
    />
  </Svg>
);

// eslint-disable-next-line import-x/no-default-export
export default AlamoLogo;
